/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMilestoneRequest
 */
export interface CreateMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMilestoneRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMilestoneRequest
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateMilestoneRequest
     */
    targetDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateMilestoneRequest
     */
    positionOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMilestoneRequest
     */
    boardVisible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMilestoneRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreateMilestoneRequest interface.
 */
export function instanceOfCreateMilestoneRequest(value: object): value is CreateMilestoneRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('targetDate' in value) || value['targetDate'] === undefined) return false;
    return true;
}

export function CreateMilestoneRequestFromJSON(json: any): CreateMilestoneRequest {
    return CreateMilestoneRequestFromJSONTyped(json, false);
}

export function CreateMilestoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMilestoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'targetDate': (new Date(json['targetDate'])),
        'positionOrder': json['positionOrder'] == null ? undefined : json['positionOrder'],
        'boardVisible': json['boardVisible'] == null ? undefined : json['boardVisible'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreateMilestoneRequestToJSON(json: any): CreateMilestoneRequest {
    return CreateMilestoneRequestToJSONTyped(json, false);
}

export function CreateMilestoneRequestToJSONTyped(value?: CreateMilestoneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'targetDate': ((value['targetDate']).toISOString().substring(0,10)),
        'positionOrder': value['positionOrder'],
        'boardVisible': value['boardVisible'],
        'effectTenantId': value['effectTenantId'],
    };
}

